module.exports = __webpack_public_path__ + "img/mobile-research&report.b80d3121.png";